import { UserTargetTypes } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';
import { Button, ButtonSize, ButtonTypes, Icon } from '../../components';
import { WeightTargetHeader } from './weight-target-header';

interface IProps {
  t: any;
  isChangingTarget: boolean;
  userTargetType: UserTargetTypes;
  close: () => void;
}

const InvalidTargetRangeComponent: FunctionComponent<IProps> = ({t, isChangingTarget, userTargetType, close}) => {

  const targetMetric = new Map([
    [UserTargetTypes.Musclemass, 'muscle mass'],
    [UserTargetTypes.Bodyweight, 'weight'],
    [UserTargetTypes.Bodyfat, 'body fat'],
]).get(userTargetType);

  return (
    <View style={styles.container}>
      <View style={styles.headingContainerStyle}>
        <WeightTargetHeader
          goToPreviousStep={close}
          showCloseButton={true}
        />
      </View>
      <View style={styles.content}>
        <View style={styles.textContainer}>
          <Text style={styles.heading}>{t('invalidTargetRange')}</Text>
          <Text style={styles.subHeading}>
            {t('dontSupportLowerTarget', {
              range: userTargetType === UserTargetTypes.Musclemass ? 'higher' : 'lower',
              metric: targetMetric,
            })}
          </Text>
        </View>
        <View style={styles.actionsContainer}>
          <Button
            title={t('dontSetTargetNow')}
            onPress={close}
            fontColor={Theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
            size={ButtonSize.NORMAL}
          />
        </View>
      </View>
    </View>
)};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  headingContainerStyle: {
    paddingBottom: defaultScale(15),
  },
  closeIconContainerStyle: {
    alignSelf: 'flex-end',
    marginHorizontal: defaultScale(15),
    zIndex: 10,
    marginTop: defaultScale(15),
  },
  content: {
    flex: 1,
    marginHorizontal: defaultScale(15)
  },
  heading: {
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(18),
  },
  subHeading: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
  },
  textContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  actionsContainer: {
    paddingBottom: defaultScale(24),
},
});

export const InvalidTargetRange = translate(['weightTarget'])(InvalidTargetRangeComponent);
